import { createSelector } from '@reduxjs/toolkit';

export const appstateSelector = (state: ReduxState) => state.appstateReducer;
export const isDeleteSimulationModalOpen = createSelector(
    appstateSelector,
    (appstate) => appstate?.isDeleteSimulationModalOpen
);

export const ruleSet = createSelector(appstateSelector, (appstate) => appstate?.ruleSet);
